import PropTypes from 'prop-types';
import React from 'react';

/**
 * A rich-text contentEditable input component.
 *
 * Uses a `<div contentEditable>` intentionally — this component requires innerHTML
 * manipulation, DOM Range caret management, and mention chip insertion via HTML fragments,
 * which cannot be replicated with a native <textarea> or <input>.
 *
 * Accessibility: contentEditable divs are natively keyboard-focusable (no tabIndex needed),
 * and aria-multiline + aria-label provide full screen-reader support.
 */
const ContentEditableInputBase = ({ as: Tag = 'div', children, ...rest }, ref) => (
   <Tag ref={ref} {...rest}>
      {children}
   </Tag>
);

ContentEditableInputBase.propTypes = {
   as: PropTypes.oneOfType([PropTypes.string, PropTypes.elementType]),
   children: PropTypes.node,
};

const ContentEditableInput = React.memo(React.forwardRef(ContentEditableInputBase));

export default ContentEditableInput;
